export default `
  subscription OnDeleteTeamMember($projectId: String!)  {
    onDeleteTeamMember (projectId: $projectId) {
      id
      projectId
    }
  }
`
